import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BooleanToTextPipe } from './shared/pipes/boolean/booleanToText.pipe';
import { GetTimePipe } from './shared/pipes/dateTime/getTime.pipe';
import { ToReadableDateTimePipe } from './shared/pipes/dateTime/ToReadableDateTime.pipe';
import { UtcToLocalPipe } from './shared/pipes/dateTime/utc-to-local.pipe';
import { NullOrEmptyToDefault } from './shared/pipes/null/NullOrEmptyToDefault.pipe';
import { ToPriceFormatPipe } from './shared/pipes/price/ToPriceFormat.pipe';
import { SafeHtmlPipe } from './shared/pipes/safe-html-pipe.pipe';
import { ToReadableTimePipe } from './shared/pipes/time/ToReadableTime.pipe';
import { FilterByIdPipe } from './shared/pipes/filter/filterById.pipe';
import { TooltipListPipe } from './shared/pipes/tooltip/tooltip-list.pipe';

@NgModule({
    declarations: [
        SafeHtmlPipe,
        BooleanToTextPipe,
        NullOrEmptyToDefault,
        ToPriceFormatPipe,
        ToReadableDateTimePipe,
        ToReadableTimePipe,
        GetTimePipe,
        FilterByIdPipe,
        UtcToLocalPipe
    ],
    exports: [
        SafeHtmlPipe,
        BooleanToTextPipe,
        NullOrEmptyToDefault,
        ToPriceFormatPipe,
        ToReadableDateTimePipe,
        ToReadableTimePipe,
        GetTimePipe,
        FilterByIdPipe,
        TooltipListPipe,
        UtcToLocalPipe
    ],
    imports: [CommonModule, TooltipListPipe],
})
export class AppPipesModule {}
